//Vendors
import $ from 'jquery';
import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import VueTheMask from 'vue-the-mask';
import VModal from 'vue-js-modal';

//Libs
import Scrolling from './libs/Scrolling';
import ScrollMagicGE from './libs/ScrollMagicGE';
import RichMenu from './libs/RichMenu';
import Modal from './libs/Modal.js';
import Inputs from './libs/Inputs';
import Home from './libs/Home';
import IsotopeStuff from './libs/IsotopeStuff';
import Accordion from './libs/Accordion';
import {breakpoint, breakpointDown, breakpointOnly} from './libs/Breakpoints';
import Responsive from './libs/Responsive';
import ScrollBar from './libs/ScrollBar';
import SocialApi from './libs/SocialApi';
// import TarteAuCitronJs from './libs/TarteAuCitronJs';
import Zendesk from './libs/Zendesk';
import HomeLazyLoad from './libs/HomeLazyLoad';

import './components';
import './filters';
import router from './router';
import HomeNews from './components/home-news';

window.jQuery = $;
require('@fancyapps/fancybox');

Vue.use(Vue2TouchEvents);
Vue.use(VueTheMask);
Vue.use(VModal, {dialog: true});

Vue.config.ignoredElements = ['script'];

export default new Vue({
    el: '#app',
    router,
    data: {
        user: window.GrandsEspaces.user,
        cart: window.GrandsEspaces.cart,
        isMobile: false,
        breakpointDownSm: false,
        breakpointDownLg: false,
        breakpointOnlyLg: false,
    },
    computed: {
        cartEmpty() {
            return Object.values(this.cart).length === 0;
        },
    },
    methods: {
        showLoginPanel() {
            this.$refs['login-panel'].issocialwall = false;
            this.$refs['login-panel'].iswishlist = false;
            this.$refs['login-panel'].isoption = false;
            Modal.showModal('#loginpanel');
        },
        showNewsletterPanel() {
            Modal.showModal('#newsletter-panel');
        },
        showAdvicePanel(order_id, cruise_name) {
            this.$refs['advice-panel'].form.order_id = order_id;
            this.$refs['advice-panel'].order_id = order_id;
            this.$refs['advice-panel'].cruise_name = cruise_name;
            Modal.showModal('#advice-panel');
        },
        goToUrl(url, desktopOnly) {
            if (desktopOnly && this.isMobile) {
                return;
            }
            window.location.href = url;
        },
    },
    mounted() {
        $(window).bind('resizeEndThrottle', () => {
            this.isMobile = window.isMobile = breakpointDown('md');
            this.breakpointDownSm = window.breakpointDownSm = breakpointDown('sm');
            this.breakpointDownLg = window.breakpointDownLg = breakpointDown('lg');
            this.breakpointOnlyLg = window.breakpointOnlyLg = breakpointOnly('lg');
        });
    },
});

// Social Api
SocialApi.init();


// Init Js
$(document).ready(() => {
    Scrolling.init();
    ScrollMagicGE.init();
    RichMenu.init();
    Modal.init();
    Inputs.floatingLabel();
    Home.init();
    IsotopeStuff.init();
    Accordion.init();
    breakpoint.init();
    Responsive.init();
    ScrollBar.init();
    HomeLazyLoad.init();
    HomeNews.init();

    if (GrandsEspaces.environnement === 'production'){
        // TarteAuCitronJs.init();
        Zendesk.init();
    }

    setTimeout(() => $('#preload').fadeOut(300), 400);

});




// WEBPACK FOOTER //
// ./assets/js/app.js